import { render, staticRenderFns } from "./QuotaUsageBar.vue?vue&type=template&id=4468694e"
import script from "./QuotaUsageBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuotaUsageBar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports